import {api, handleApiError, PagedResource, ServiceResponse} from "../ApiClient";
import {User} from "./UserService";

export interface ReviewResource {
    message: string
    rating: number
    shareMessageWithCaddie: boolean
    attributes: string[]
    associations: ReviewAssociationResource[]

    caddieUser?: User
    author?: User
}

export interface ReviewSearchStatisticsRequest {
    clubId: string

    caddieIds?: string[]
    memberIds?: string[]

    starRating?: number[]

    from?: string
    to?: string
}

export interface ReviewSearchRequest extends ReviewSearchStatisticsRequest {
    page: number
    size: number
}

export interface ReviewSearchStatisticsResource {
    overallRating: number
    reviewCount: number

    fiveStarReviews: number
    fourStarReviews: number
    threeStarReviews: number
    twoStarReviews: number
    oneStarReviews: number

    attributes: {
        label: string
        value: number
    }[]
}

export interface ReviewAssociationResource {
    associationId: string
    associationType: string
}

export interface Review extends ReviewResource {
    id: string
    created: string
}

export interface ReviewSearchStatisticsResponse extends ServiceResponse {
    statistics?: ReviewSearchStatisticsResource
}


export interface ReviewPagedResource extends PagedResource {
    resource: Review[]
}

export interface PageableReviewResponse extends ServiceResponse {
    page?: ReviewPagedResource
}

export interface CreateReviewResponse extends ServiceResponse {
    review?: Review
}

export const ReviewService = () => {

    const search = async (resource: ReviewSearchRequest): Promise<PageableReviewResponse> => {
        return api.post<ReviewPagedResource>(`/api/1/reviews-search`, resource)
            .then((resp) => {
                if (resp && resp.status === 200) {
                    return {
                        page: resp.data
                    }
                }

                return handleApiError(resp)
            })
            .catch(handleApiError)
    }

    const searchStatistics = async (resource: ReviewSearchStatisticsRequest): Promise<ReviewSearchStatisticsResponse> => {
        return api.post<ReviewSearchStatisticsResource>(`/api/1/reviews-search-stats`, resource)
            .then((resp) => {
                if (resp && resp.status === 200) {
                    return {
                        statistics: resp.data
                    }
                }

                return handleApiError(resp)
            })
            .catch(handleApiError)
    }

    const create = async (resource: ReviewResource): Promise<CreateReviewResponse> => {
        return api.post<Review>(`/api/1/reviews`, resource)
            .then((resp) => {
                if (resp && resp.status === 200) {
                    return {
                        review: resp.data
                    }
                }

                return handleApiError(resp)
            })
            .catch(handleApiError)
    }

    return {
        searchReviews: search,
        searchStatistics,
        createReview: create,
    }
}
